import { useId, type ReactNode } from 'react';
import { createPortal } from 'react-dom';
import { X } from 'lucide-react';
import { useOverlay } from './use-overlay';
import styles from './Drawer.module.css';

export type DrawerProps = {
  open: boolean;
  onClose: () => void;
  title?: ReactNode;
  children: ReactNode;
  footer?: ReactNode;
  /** Genis ekranda hangi kenardan girsin. Dar ekranda her zaman ALTTAN gelir. */
  side?: 'start' | 'end';
  className?: string;
};

/**
 * Mobil taraftaki `Sheet` bileseninin web karsiligi.
 *
 * Genis ekranda kenar cekmecesi, DAR EKRANDA ALT SAYFA (bottom sheet) gibi
 * davranir — filtre panelinin telefonda ekranin yarisini kaplamasi dogru,
 * saga yapismis dar bir sutun olmasi degil. Gecis tamamen CSS'te
 * (Drawer.module.css icindeki max-width: 640px sorgusu); JS'te ekran genisligi
 * olculmez, boylece yeniden boyutlandirmada yanlis durum kalmaz.
 */
export function Drawer({
  open,
  onClose,
  title,
  children,
  footer,
  side = 'end',
  className,
}: DrawerProps) {
  const titleId = useId();
  useOverlay(open, onClose);

  if (!open) return null;

  return createPortal(
    <div
      className={styles.scrim}
      onMouseDown={(event) => {
        if (event.target === event.currentTarget) onClose();
      }}
    >
      <aside
        role="dialog"
        aria-modal="true"
        aria-labelledby={title ? titleId : undefined}
        className={[styles.panel, styles[side], className].filter(Boolean).join(' ')}
      >
        <div className={styles.grabber} aria-hidden="true" />
        {title ? (
          <header className={styles.header}>
            <h2 className={styles.title} id={titleId}>
              {title}
            </h2>
            <button type="button" className={styles.close} onClick={onClose} aria-label="Kapat">
              <X size={18} aria-hidden="true" />
            </button>
          </header>
        ) : null}
        <div className={styles.body}>{children}</div>
        {footer ? <footer className={styles.footer}>{footer}</footer> : null}
      </aside>
    </div>,
    document.body,
  );
}
